import { updateInitialParameters } from '../actions/internalActions';
import { getGroupMailboxInfo } from 'owa-group-common';
import { updateItemsViewCache } from '../store/cache';
import { getCurrentGroupSmtpAddress } from 'owa-groups-shared-store';

export async function onFilesViewNavigation() {
    await updateInitialParameters(getGroupMailboxInfo(getCurrentGroupSmtpAddress()));
    updateItemsViewCache();
}
